import DOMPurify from "dompurify";

export default class AntavoPointsLoader {
    private rewardsContainer: HTMLElement | null = document.querySelector('.rewards-product-container');
    private rewardsContainerSkeleton: HTMLElement | null = document.querySelector('.rewards-product-skeleton');
    private rewardsProductContent: HTMLElement | null = document.querySelector('.rewards-product-content');
    private rewardsProductPoints: HTMLElement | null = document.querySelector('.rewards-product__points')

    init(): void
    {
        if (this.rewardsContainer == null) {
            return;
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.startLoading());
        } else {
            this.startLoading();
        }
    }

    private startLoading(): void
    {
        this.rewardsContainerSkeleton?.classList.remove('u-hidden');
        this.loadPoints();
    }

    private hideLoading(): void
    {
        this.rewardsContainerSkeleton?.classList.add('u-hidden');
    }

    private showContent(): void
    {
        this.rewardsProductContent?.classList.remove('u-hidden');
    }

    private setPoints(points: string): void {
        if (this.rewardsProductPoints === null) {
            return;
        }
        this.rewardsProductPoints.innerHTML = DOMPurify.sanitize(points, {
            ADD_TAGS: ['svg' , 'use'],
            ADD_ATTR: ['xlink:href']
        });
        this.hideLoading();
        this.showContent();
    }

    private loadPoints(): void {
        const productId: string | undefined = this.rewardsProductContent?.getAttribute('data-product-id') ?? undefined;

        if (productId === undefined) {
            return;
        }

        fetch(`/api/antavo/points?product_id=${encodeURIComponent(parseInt(productId))}`, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.text();
        })
        .then(points => {
            this.setPoints(points);
        })
        .catch((error: unknown) => {
            console.log('Failed to load antavo points: ' + (error instanceof Error ? error.message : String(error)));
            this.hideLoading();
        });
    }
}

const loader = new AntavoPointsLoader();
loader.init();